// mock

import greenStarIcon from '@/assets/green_star.svg';
import { PlanItemProps } from '@/components/PlanTable/types';
import { deepCopy, uid } from '@/utils';
import { Message } from './types';

export const mockPlanPart1: Message[] = [
  {
    content: '[START_GENERATING_PLAN]',
    created: 1,
    session_id: 1,
    type: 'system_message',
  },
  {
    session_id: 1964,
    type: 'plan_stage_progress',
    content: {
      stage: 'STARTING',
      title: 'Generating task starting',
      progress_min: 0,
      progress_max: 10,
      estimated_time: 5,
    },
    created: 1756449331821,
  },
  {
    session_id: 1964,
    type: 'plan_stage_progress',
    content: {
      stage: 'FINALIZING',
      title: 'Tracking plan Finalizing',
      progress_min: 10,
      progress_max: 100,
      estimated_time: 30,
    },
    created: 1756449332286,
  },
  {
    session_id: 1964,
    type: 'plan_stage_progress',
    content: {
      stage: 'COMPLETED',
      title: 'Task Completed',
      progress_min: 100,
      progress_max: 100,
      estimated_time: 0,
    },
    created: 1756449361131,
  },
  {
    content: {
      name: 'start_free_trial_click',
      description:
        "Tracks clicks on the 'Free Trial'/'Try It for Free'/'Claim 2 Free Deploys' buttons to measure user interest in starting a free experience after ad click. This event is a key touchpoint in the ad-to-conversion funnel, indicating strong user intent. It helps evaluate which Google Ads campaigns effectively drive initial product adoption and can be used as a conversion event for Google Ads optimization.",
      journey_stage: 'Primary CTA',
      page_group_ids: ['1001', '5001', '6001', '7001'],
      page_group_names: [
        'Homepage',
        'Pricing Page',
        'Solution Page - Agency',
        'Tracking Plan Report Page',
      ],
      page_group_infos: [
        {
          group_name: 'Homepage',
          group_id: '1001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/',
              title:
                'JTracking - AI Agent for Google Tag Manager Event Tracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Pricing Page',
          group_id: '5001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/pricing/',
              title:
                'Flexible Pricing | Start Free & Pay Only When You Deploy – JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Solution Page - Agency',
          group_id: '6001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/solution/agency/',
              title:
                'Built for Agencies: Tailored Tracking Solutions - JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Tracking Plan Report Page',
          group_id: '7001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/tracking-plan-report/',
              title:
                'Pre-Launch Tracking Report | Simulate a Professional Plan Tailored for Your Site – JTracking',
              based_on: true,
            },
          ],
        },
      ],
      gen_node_title: 'exp-sonnet (full)',
      properties: [
        {
          name: 'button_position',
          property_type: 'string',
          description: 'The component location where the button is positioned',
          examples: [
            'header',
            'Simplify Ad Tracking Now',
            'Start Free, Scale on Demand',
          ],
        },
        {
          name: 'plan_name',
          property_type: 'string',
          description: 'The name of the free plan or trial being activated',
          examples: ['Free', '2 Free Deploys', 'Free Trial'],
        },
        {
          name: 'plan_price',
          property_type: 'string',
          description: 'The price of the free offering',
          examples: ['$0', 'for 2 deploys'],
        },
        {
          name: 'button_name',
          property_type: 'string',
          description: 'The complete text of the clicked button from UI',
          examples: ['Free Trial', 'Try It for Free', 'Claim 2 Free Deploys'],
        },
      ],
    },
    created: 1,
    session_id: 1,
    type: 'tracking_event',
  },
  {
    content: {
      name: 'explore_demo_click',
      description:
        "Tracks clicks on the 'Explore Demo'/'Go to JTracking Demo' buttons to measure user interest in product demonstrations after ad click. This indicates active engagement with the product's value proposition. It helps identify which Google Ads creatives and placements lead to deeper exploration and can serve as a valuable micro-conversion for Google Ads Smart Bidding.",
      journey_stage: 'Primary CTA',
      page_group_ids: ['1001', '2001', '5001', '6001', '7001'],
      page_group_names: [
        'Homepage',
        'Demo Report Page',
        'Pricing Page',
        'Solution Page - Agency',
        'Tracking Plan Report Page',
      ],
      page_group_infos: [
        {
          group_name: 'Homepage',
          group_id: '1001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/',
              title:
                'JTracking - AI Agent for Google Tag Manager Event Tracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Demo Report Page',
          group_id: '2001',
          page_infos: [
            {
              url: 'https://demo.jtracking.ai/test-report/d07a64900df04d33be11cc3b9d4a45de',
              title: 'Pre-Launch Tracking Report',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Pricing Page',
          group_id: '5001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/pricing/',
              title:
                'Flexible Pricing | Start Free & Pay Only When You Deploy – JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Solution Page - Agency',
          group_id: '6001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/solution/agency/',
              title:
                'Built for Agencies: Tailored Tracking Solutions - JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Tracking Plan Report Page',
          group_id: '7001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/tracking-plan-report/',
              title:
                'Pre-Launch Tracking Report | Simulate a Professional Plan Tailored for Your Site – JTracking',
              based_on: true,
            },
          ],
        },
      ],
      gen_node_title: 'exp-sonnet (full)',
      properties: [
        {
          name: 'button_position',
          property_type: 'string',
          description:
            'The component location where the explore demo button is positioned',
          examples: [
            'header',
            'Let AI Agent Handle Ad Conversion Tracking',
            'See Your Data in Action Before You Launch',
          ],
        },
        {
          name: 'button_name',
          property_type: 'string',
          description: 'The complete text of the clicked button from UI',
          examples: ['Explore Demo', 'Go to JTracking Demo'],
        },
      ],
    },
    created: 1,
    session_id: 1,
    type: 'tracking_event',
  },
  {
    content: {
      name: 'login_click',
      description:
        "Tracks clicks on the 'Log In' button to measure user intent to access their account or proceed with an authentication flow after ad exposure. This event is critical for understanding the ad-driven user journey for existing users or those returning to complete a process. It helps attribute account engagement to specific Google Ads campaigns and can be used for remarketing list building in Google Ads.",
      journey_stage: 'Primary CTA',
      page_group_ids: ['1001', '5001', '6001', '7001', '8001'],
      page_group_names: [
        'Homepage',
        'Pricing Page',
        'Solution Page - Agency',
        'Tracking Plan Report Page',
        'GA Extension Page',
      ],
      page_group_infos: [
        {
          group_name: 'Homepage',
          group_id: '1001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/',
              title:
                'JTracking - AI Agent for Google Tag Manager Event Tracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Pricing Page',
          group_id: '5001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/pricing/',
              title:
                'Flexible Pricing | Start Free & Pay Only When You Deploy – JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Solution Page - Agency',
          group_id: '6001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/solution/agency/',
              title:
                'Built for Agencies: Tailored Tracking Solutions - JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Tracking Plan Report Page',
          group_id: '7001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/tracking-plan-report/',
              title:
                'Pre-Launch Tracking Report | Simulate a Professional Plan Tailored for Your Site – JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'GA Extension Page',
          group_id: '8001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/ga-extension/',
              title: 'Untitled',
              based_on: true,
            },
          ],
        },
      ],
      gen_node_title: 'exp-sonnet (full)',
      properties: [
        {
          name: 'button_position',
          property_type: 'string',
          description:
            'The component location where the log in button is positioned',
          examples: ['header'],
        },
        {
          name: 'button_name',
          property_type: 'string',
          description: 'The complete text of the clicked button from UI',
          examples: ['Log In'],
        },
      ],
    },
    created: 1,
    session_id: 1,
    type: 'tracking_event',
  },
  {
    content: {
      name: 'subscribe_now_click',
      description:
        "Tracks clicks on the 'Subscribe Now' button to measure user intent to subscribe to a paid plan after ad click. This is a direct indicator of high conversion intent. It provides direct measurement of Google Ads campaign ROI for subscription-based products and should be configured as a primary conversion goal in Google Ads for accurate revenue attribution.",
      journey_stage: 'Primary CTA',
      page_group_ids: ['1001', '5001', '6001'],
      page_group_names: ['Homepage', 'Pricing Page', 'Solution Page - Agency'],
      page_group_infos: [
        {
          group_name: 'Homepage',
          group_id: '1001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/',
              title:
                'JTracking - AI Agent for Google Tag Manager Event Tracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Pricing Page',
          group_id: '5001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/pricing/',
              title:
                'Flexible Pricing | Start Free & Pay Only When You Deploy – JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Solution Page - Agency',
          group_id: '6001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/solution/agency/',
              title:
                'Built for Agencies: Tailored Tracking Solutions - JTracking',
              based_on: true,
            },
          ],
        },
      ],
      gen_node_title: 'exp-sonnet (full)',
      properties: [
        {
          name: 'button_position',
          property_type: 'string',
          description:
            'The component location where the subscribe button is positioned',
          examples: ['Start Free, Scale on Demand'],
        },
        {
          name: 'plan_name',
          property_type: 'string',
          description: 'The name of the subscription plan being selected',
          examples: ['Subscription'],
        },
        {
          name: 'plan_price',
          property_type: 'string',
          description: 'The monthly price of the selected plan',
          examples: ['$20'],
        },
        {
          name: 'billing_cycle',
          property_type: 'string',
          description: 'The billing frequency for the subscription',
          examples: ['/Month'],
        },
        {
          name: 'button_name',
          property_type: 'string',
          description: 'The complete text of the clicked button from UI',
          examples: ['Subscribe Now'],
        },
      ],
    },
    created: 1,
    session_id: 1,
    type: 'tracking_event',
  },
  {
    session_id: 1964,
    type: 'suggestion',
    content: {
      suggestion1: 'How do I apply this tracking plan to my GTM?',
      suggestion2: 'Can I modify this new tracking plan further?',
      suggestion3: 'I want to update the current GTM configuration',
    },
    created: 1756449365045,
  },
  {
    content: 'done',
    created: 1,
    session_id: 1,
    type: 'done',
  },
];

export const mockPlanPart2: Message[] = [
  {
    content: {
      name: 'start_free_trial_click',
      description:
        "Tracks clicks on the 'Free Trial'/'Try It for Free'/'Claim 2 Free Deploys' buttons to measure user interest in starting a free experience after ad click. This event is a key touchpoint in the ad-to-conversion funnel, indicating strong user intent. It helps evaluate which Google Ads campaigns effectively drive initial product adoption and can be used as a conversion event for Google Ads optimization.",
      journey_stage: 'Primary CTA',
      page_group_ids: ['1001', '5001', '6001', '7001'],
      page_group_names: [
        'Homepage',
        'Pricing Page',
        'Solution Page - Agency',
        'Tracking Plan Report Page',
      ],
      page_group_infos: [
        {
          group_name: 'Homepage',
          group_id: '1001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/',
              title:
                'JTracking - AI Agent for Google Tag Manager Event Tracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Pricing Page',
          group_id: '5001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/pricing/',
              title:
                'Flexible Pricing | Start Free & Pay Only When You Deploy – JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Solution Page - Agency',
          group_id: '6001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/solution/agency/',
              title:
                'Built for Agencies: Tailored Tracking Solutions - JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Tracking Plan Report Page',
          group_id: '7001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/tracking-plan-report/',
              title:
                'Pre-Launch Tracking Report | Simulate a Professional Plan Tailored for Your Site – JTracking',
              based_on: true,
            },
          ],
        },
      ],
      gen_node_title: 'exp-sonnet (full)',
      properties: [
        {
          name: 'button_position',
          property_type: 'string',
          description: 'The component location where the button is positioned',
          examples: [
            'header',
            'Simplify Ad Tracking Now',
            'Start Free, Scale on Demand',
          ],
        },
        {
          name: 'plan_name',
          property_type: 'string',
          description: 'The name of the free plan or trial being activated',
          examples: ['Free', '2 Free Deploys', 'Free Trial'],
        },
        {
          name: 'plan_price',
          property_type: 'string',
          description: 'The price of the free offering',
          examples: ['$0', 'for 2 deploys'],
        },
        {
          name: 'button_name',
          property_type: 'string',
          description: 'The complete text of the clicked button from UI',
          examples: ['Free Trial', 'Try It for Free', 'Claim 2 Free Deploys'],
        },
      ],
    },
    created: 1,
    session_id: 1,
    type: 'tracking_event',
  },
  {
    content: {
      name: 'explore_demo_click',
      description:
        "Tracks clicks on the 'Explore Demo'/'Go to JTracking Demo' buttons to measure user interest in product demonstrations after ad click. This indicates active engagement with the product's value proposition. It helps identify which Google Ads creatives and placements lead to deeper exploration and can serve as a valuable micro-conversion for Google Ads Smart Bidding.",
      journey_stage: 'Primary CTA',
      page_group_ids: ['1001', '2001', '5001', '6001', '7001'],
      page_group_names: [
        'Homepage',
        'Demo Report Page',
        'Pricing Page',
        'Solution Page - Agency',
        'Tracking Plan Report Page',
      ],
      page_group_infos: [
        {
          group_name: 'Homepage',
          group_id: '1001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/',
              title:
                'JTracking - AI Agent for Google Tag Manager Event Tracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Demo Report Page',
          group_id: '2001',
          page_infos: [
            {
              url: 'https://demo.jtracking.ai/test-report/d07a64900df04d33be11cc3b9d4a45de',
              title: 'Pre-Launch Tracking Report',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Pricing Page',
          group_id: '5001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/pricing/',
              title:
                'Flexible Pricing | Start Free & Pay Only When You Deploy – JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Solution Page - Agency',
          group_id: '6001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/solution/agency/',
              title:
                'Built for Agencies: Tailored Tracking Solutions - JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Tracking Plan Report Page',
          group_id: '7001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/tracking-plan-report/',
              title:
                'Pre-Launch Tracking Report | Simulate a Professional Plan Tailored for Your Site – JTracking',
              based_on: true,
            },
          ],
        },
      ],
      gen_node_title: 'exp-sonnet (full)',
      properties: [
        {
          name: 'button_position',
          property_type: 'string',
          description:
            'The component location where the explore demo button is positioned',
          examples: [
            'header',
            'Let AI Agent Handle Ad Conversion Tracking',
            'See Your Data in Action Before You Launch',
          ],
        },
        {
          name: 'button_name',
          property_type: 'string',
          description: 'The complete text of the clicked button from UI',
          examples: ['Explore Demo', 'Go to JTracking Demo'],
        },
      ],
    },
    created: 1,
    session_id: 1,
    type: 'tracking_event',
  },
  {
    content: {
      name: 'login_click',
      description:
        "Tracks clicks on the 'Log In' button to measure user intent to access their account or proceed with an authentication flow after ad exposure. This event is critical for understanding the ad-driven user journey for existing users or those returning to complete a process. It helps attribute account engagement to specific Google Ads campaigns and can be used for remarketing list building in Google Ads.",
      journey_stage: 'Primary CTA',
      page_group_ids: ['1001', '5001', '6001', '7001', '8001'],
      page_group_names: [
        'Homepage',
        'Pricing Page',
        'Solution Page - Agency',
        'Tracking Plan Report Page',
        'GA Extension Page',
      ],
      page_group_infos: [
        {
          group_name: 'Homepage',
          group_id: '1001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/',
              title:
                'JTracking - AI Agent for Google Tag Manager Event Tracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Pricing Page',
          group_id: '5001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/pricing/',
              title:
                'Flexible Pricing | Start Free & Pay Only When You Deploy – JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Solution Page - Agency',
          group_id: '6001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/solution/agency/',
              title:
                'Built for Agencies: Tailored Tracking Solutions - JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Tracking Plan Report Page',
          group_id: '7001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/tracking-plan-report/',
              title:
                'Pre-Launch Tracking Report | Simulate a Professional Plan Tailored for Your Site – JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'GA Extension Page',
          group_id: '8001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/ga-extension/',
              title: 'Untitled',
              based_on: true,
            },
          ],
        },
      ],
      gen_node_title: 'exp-sonnet (full)',
      properties: [
        {
          name: 'button_position',
          property_type: 'string',
          description:
            'The component location where the log in button is positioned',
          examples: ['header'],
        },
        {
          name: 'button_name',
          property_type: 'string',
          description: 'The complete text of the clicked button from UI',
          examples: ['Log In'],
        },
      ],
    },
    created: 1,
    session_id: 1,
    type: 'tracking_event',
  },
  {
    content: {
      name: 'subscribe_now_click',
      description:
        "Tracks clicks on the 'Subscribe Now' button to measure user intent to subscribe to a paid plan after ad click. This is a direct indicator of high conversion intent. It provides direct measurement of Google Ads campaign ROI for subscription-based products and should be configured as a primary conversion goal in Google Ads for accurate revenue attribution.",
      journey_stage: 'Primary CTA',
      page_group_ids: ['1001', '5001', '6001'],
      page_group_names: ['Homepage', 'Pricing Page', 'Solution Page - Agency'],
      page_group_infos: [
        {
          group_name: 'Homepage',
          group_id: '1001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/',
              title:
                'JTracking - AI Agent for Google Tag Manager Event Tracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Pricing Page',
          group_id: '5001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/pricing/',
              title:
                'Flexible Pricing | Start Free & Pay Only When You Deploy – JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Solution Page - Agency',
          group_id: '6001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/solution/agency/',
              title:
                'Built for Agencies: Tailored Tracking Solutions - JTracking',
              based_on: true,
            },
          ],
        },
      ],
      gen_node_title: 'exp-sonnet (full)',
      properties: [
        {
          name: 'button_position',
          property_type: 'string',
          description:
            'The component location where the subscribe button is positioned',
          examples: ['Start Free, Scale on Demand'],
        },
        {
          name: 'plan_name',
          property_type: 'string',
          description: 'The name of the subscription plan being selected',
          examples: ['Subscription'],
        },
        {
          name: 'plan_price',
          property_type: 'string',
          description: 'The monthly price of the selected plan',
          examples: ['$20'],
        },
        {
          name: 'billing_cycle',
          property_type: 'string',
          description: 'The billing frequency for the subscription',
          examples: ['/Month'],
        },
        {
          name: 'button_name',
          property_type: 'string',
          description: 'The complete text of the clicked button from UI',
          examples: ['Subscribe Now'],
        },
      ],
    },
    created: 1,
    session_id: 1,
    type: 'tracking_event',
  },
  {
    content: 'done',
    created: 1,
    session_id: 1,
    type: 'done',
  },
];

export const mockPlanPart3: Message[] = [
  {
    content: {
      name: 'start_free_trial_click',
      description:
        "123 Tracks clicks on the 'Free Trial'/'Try It for Free'/'Claim 2 Free Deploys' buttons to measure user interest in starting a free experience after ad click. This event is a key touchpoint in the ad-to-conversion funnel, indicating strong user intent. It helps evaluate which Google Ads campaigns effectively drive initial product adoption and can be used as a conversion event for Google Ads optimization.",
      journey_stage: 'Primary CTA',
      page_group_ids: ['1001', '5001', '6001', '7001'],
      page_group_names: [
        'Homepage',
        'Pricing Page',
        'Solution Page - Agency',
        'Tracking Plan Report Page',
      ],
      page_group_infos: [
        {
          group_name: 'Homepage',
          group_id: '1001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/',
              title:
                'JTracking - AI Agent for Google Tag Manager Event Tracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Pricing Page',
          group_id: '5001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/pricing/',
              title:
                'Flexible Pricing | Start Free & Pay Only When You Deploy – JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Solution Page - Agency',
          group_id: '6001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/solution/agency/',
              title:
                'Built for Agencies: Tailored Tracking Solutions - JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Tracking Plan Report Page',
          group_id: '7001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/tracking-plan-report/',
              title:
                'Pre-Launch Tracking Report | Simulate a Professional Plan Tailored for Your Site – JTracking',
              based_on: true,
            },
          ],
        },
      ],
      gen_node_title: 'exp-sonnet (full)',
      properties: [
        {
          name: 'button_position',
          property_type: 'string',
          description: 'The component location where the button is positioned',
          examples: [
            'header',
            'Simplify Ad Tracking Now',
            'Start Free, Scale on Demand',
          ],
        },
        {
          name: 'plan_name',
          property_type: 'string',
          description: 'The name of the free plan or trial being activated',
          examples: ['Free', '2 Free Deploys', 'Free Trial'],
        },
        {
          name: 'plan_price',
          property_type: 'string',
          description: 'The price of the free offering',
          examples: ['$0', 'for 2 deploys'],
        },
        {
          name: 'button_name',
          property_type: 'string',
          description: 'The complete text of the clicked button from UI',
          examples: ['Free Trial', 'Try It for Free', 'Claim 2 Free Deploys'],
        },
      ],
    },
    created: 1,
    session_id: 1,
    type: 'tracking_event',
  },
  {
    content: {
      name: 'explore_demo_click',
      description:
        "Tracks clicks on the 'Explore Demo'/'Go to JTracking Demo' buttons to measure user interest in product demonstrations after ad click. This indicates active engagement with the product's value proposition. It helps identify which Google Ads creatives and placements lead to deeper exploration and can serve as a valuable micro-conversion for Google Ads Smart Bidding.",
      journey_stage: 'Primary CTA',
      page_group_ids: ['1001', '2001', '5001', '6001', '7001'],
      page_group_names: [
        'Homepage',
        'Demo Report Page',
        'Pricing Page',
        'Solution Page - Agency',
        'Tracking Plan Report Page',
      ],
      page_group_infos: [
        {
          group_name: 'Homepage',
          group_id: '1001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/',
              title:
                'JTracking - AI Agent for Google Tag Manager Event Tracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Demo Report Page',
          group_id: '2001',
          page_infos: [
            {
              url: 'https://demo.jtracking.ai/test-report/d07a64900df04d33be11cc3b9d4a45de',
              title: 'Pre-Launch Tracking Report',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Pricing Page',
          group_id: '5001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/pricing/',
              title:
                'Flexible Pricing | Start Free & Pay Only When You Deploy – JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Solution Page - Agency',
          group_id: '6001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/solution/agency/',
              title:
                'Built for Agencies: Tailored Tracking Solutions - JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Tracking Plan Report Page',
          group_id: '7001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/tracking-plan-report/',
              title:
                'Pre-Launch Tracking Report | Simulate a Professional Plan Tailored for Your Site – JTracking',
              based_on: true,
            },
          ],
        },
      ],
      gen_node_title: 'exp-sonnet (full)',
      properties: [
        {
          name: 'button_position',
          property_type: 'string',
          description:
            'The component location where the explore demo button is positioned',
          examples: [
            'header',
            'Let AI Agent Handle Ad Conversion Tracking',
            'See Your Data in Action Before You Launch',
          ],
        },
        {
          name: 'button_name',
          property_type: 'string',
          description: 'The complete text of the clicked button from UI',
          examples: ['Explore Demo', 'Go to JTracking Demo'],
        },
      ],
    },
    created: 1,
    session_id: 1,
    type: 'tracking_event',
  },
  {
    content: {
      name: 'login_click',
      description:
        "Tracks clicks on the 'Log In' button to measure user intent to access their account or proceed with an authentication flow after ad exposure. This event is critical for understanding the ad-driven user journey for existing users or those returning to complete a process. It helps attribute account engagement to specific Google Ads campaigns and can be used for remarketing list building in Google Ads.",
      journey_stage: 'Primary CTA',
      page_group_ids: ['1001', '5001', '6001', '7001', '8001'],
      page_group_names: [
        'Homepage',
        'Pricing Page',
        'Solution Page - Agency',
        'Tracking Plan Report Page',
        'GA Extension Page',
      ],
      page_group_infos: [
        {
          group_name: 'Homepage',
          group_id: '1001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/',
              title:
                'JTracking - AI Agent for Google Tag Manager Event Tracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Pricing Page',
          group_id: '5001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/pricing/',
              title:
                'Flexible Pricing | Start Free & Pay Only When You Deploy – JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Solution Page - Agency',
          group_id: '6001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/solution/agency/',
              title:
                'Built for Agencies: Tailored Tracking Solutions - JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Tracking Plan Report Page',
          group_id: '7001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/tracking-plan-report/',
              title:
                'Pre-Launch Tracking Report | Simulate a Professional Plan Tailored for Your Site – JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'GA Extension Page',
          group_id: '8001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/ga-extension/',
              title: 'Untitled',
              based_on: true,
            },
          ],
        },
      ],
      gen_node_title: 'exp-sonnet (full)',
      properties: [
        {
          name: 'button_position',
          property_type: 'string',
          description:
            'The component location where the log in button is positioned',
          examples: ['header'],
        },
        {
          name: 'button_name',
          property_type: 'string',
          description: 'The complete text of the clicked button from UI',
          examples: ['Log In'],
        },
      ],
    },
    created: 1,
    session_id: 1,
    type: 'tracking_event',
  },
  {
    content: {
      name: 'subscribe_now_click 123',
      description:
        "Tracks clicks on the 'Subscribe Now' button to measure user intent to subscribe to a paid plan after ad click. This is a direct indicator of high conversion intent. It provides direct measurement of Google Ads campaign ROI for subscription-based products and should be configured as a primary conversion goal in Google Ads for accurate revenue attribution.",
      journey_stage: 'Primary CTA',
      page_group_ids: ['1001', '5001', '6001'],
      page_group_names: ['Homepage', 'Pricing Page', 'Solution Page - Agency'],
      page_group_infos: [
        {
          group_name: 'Homepage',
          group_id: '1001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/',
              title:
                'JTracking - AI Agent for Google Tag Manager Event Tracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Pricing Page',
          group_id: '5001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/pricing/',
              title:
                'Flexible Pricing | Start Free & Pay Only When You Deploy – JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Solution Page - Agency',
          group_id: '6001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/solution/agency/',
              title:
                'Built for Agencies: Tailored Tracking Solutions - JTracking',
              based_on: true,
            },
          ],
        },
      ],
      gen_node_title: 'exp-sonnet (full)',
      properties: [
        {
          name: 'button_position',
          property_type: 'string',
          description:
            'The component location where the subscribe button is positioned',
          examples: ['Start Free, Scale on Demand'],
        },
        {
          name: 'plan_name',
          property_type: 'string',
          description: 'The name of the subscription plan being selected',
          examples: ['Subscription'],
        },
        {
          name: 'plan_price',
          property_type: 'string',
          description: 'The monthly price of the selected plan',
          examples: ['$20'],
        },
        {
          name: 'billing_cycle',
          property_type: 'string',
          description: 'The billing frequency for the subscription',
          examples: ['/Month'],
        },
        {
          name: 'button_name',
          property_type: 'string',
          description: 'The complete text of the clicked button from UI',
          examples: ['Subscribe Now'],
        },
      ],
    },
    created: 1,
    session_id: 1,
    type: 'tracking_event',
  },
  {
    content: 'done',
    created: 1,
    session_id: 1,
    type: 'done',
  },
];

export const mockSuggestion: Message[] = [
  {
    content: {
      name: 'start_free_trial_click',
      description:
        "123 Tracks clicks on the 'Free Trial'/'Try It for Free'/'Claim 2 Free Deploys' buttons to measure user interest in starting a free experience after ad click. This event is a key touchpoint in the ad-to-conversion funnel, indicating strong user intent. It helps evaluate which Google Ads campaigns effectively drive initial product adoption and can be used as a conversion event for Google Ads optimization.",
      journey_stage: 'Primary CTA',
      page_group_ids: ['1001', '5001', '6001', '7001'],
      page_group_names: [
        'Homepage',
        'Pricing Page',
        'Solution Page - Agency',
        'Tracking Plan Report Page',
      ],
      page_group_infos: [
        {
          group_name: 'Homepage',
          group_id: '1001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/',
              title:
                'JTracking - AI Agent for Google Tag Manager Event Tracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Pricing Page',
          group_id: '5001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/pricing/',
              title:
                'Flexible Pricing | Start Free & Pay Only When You Deploy – JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Solution Page - Agency',
          group_id: '6001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/solution/agency/',
              title:
                'Built for Agencies: Tailored Tracking Solutions - JTracking',
              based_on: true,
            },
          ],
        },
        {
          group_name: 'Tracking Plan Report Page',
          group_id: '7001',
          page_infos: [
            {
              url: 'https://www.jtracking.ai/tracking-plan-report/',
              title:
                'Pre-Launch Tracking Report | Simulate a Professional Plan Tailored for Your Site – JTracking',
              based_on: true,
            },
          ],
        },
      ],
      gen_node_title: 'exp-sonnet (full)',
      properties: [
        {
          name: 'button_position',
          property_type: 'string',
          description: 'The component location where the button is positioned',
          examples: [
            'header',
            'Simplify Ad Tracking Now',
            'Start Free, Scale on Demand',
          ],
        },
        {
          name: 'plan_name',
          property_type: 'string',
          description: 'The name of the free plan or trial being activated',
          examples: ['Free', '2 Free Deploys', 'Free Trial'],
        },
        {
          name: 'plan_price',
          property_type: 'string',
          description: 'The price of the free offering',
          examples: ['$0', 'for 2 deploys'],
        },
        {
          name: 'button_name',
          property_type: 'string',
          description: 'The complete text of the clicked button from UI',
          examples: ['Free Trial', 'Try It for Free', 'Claim 2 Free Deploys'],
        },
      ],
    },
    created: 1,
    session_id: 1,
    type: 'tracking_event',
  },
  {
    session_id: 2011,
    type: 'suggestion',
    content: {
      suggestion1: 'I want to modify the free trial event on my site.',
      suggestion2: 'How do I connect this plan to my GTM?',
      suggestion3: 'Can you add scroll tracking to all my pages?',
    },
    created: 1756874600714,
  },
  {
    session_id: 2011,
    type: 'done',
    content: 'done',
    created: 1756874600714,
  },
];

export const mockMessage: Message[] = [
  {
    session_id: 2029,
    type: 'message',
    content: 'To connect your',
    created: 1757324292525,
  },

  {
    session_id: 2029,
    type: 'message',
    content:
      ' tracking plan to Google Tag Manager (GTM), you\'ll use the "Authorize & Deploy to',
    created: 1757324292602,
  },

  {
    session_id: 2029,
    type: 'message',
    content:
      ' GTM" button. This will guide you through the process of syncing your plan.',
    created: 1757324292686,
  },

  {
    session_id: 2029,
    type: 'message',
    content:
      '\n\nHere\'s a summary of the steps involved:\n\n1.  **Click "Authorize & Deploy to GTM"**: This button is usually associated with the "My tracking plan',
    created: 1757324292833,
  },

  {
    session_id: 2029,
    type: 'message',
    content:
      '" workspace in the JTracking interface.\n2.  **Provide GTM Details**: A prompt will appear asking for your GTM "Account ID", "Container ID", and "',
    created: 1757324292976,
  },

  {
    session_id: 2029,
    type: 'message',
    content:
      'Workspace ID". Select these from the dropdown menus. If you haven\'t authorized JTracking to access your GTM account before, you\'ll be prompted to do so.\n3.  **Initiate Sync**: Click "Continue"',
    created: 1757324293183,
  },

  {
    session_id: 2029,
    type: 'message',
    content:
      ' to start the synchronization process.\n4.  **Monitor Sync Status**: A "Syncing GTM configuration" status window will show the progress. JTracking will generate GTM configurations, sync them, and perform tests.\n5.  **',
    created: 1757324293473,
  },

  {
    session_id: 2029,
    type: 'message',
    content:
      'Review Pre-Launch Tracking Report**: Once complete, you\'ll have access to a "Pre-Launch Tracking Report" which documents the automated testing of your new GTM configurations. This report helps you verify how tracking will function before it goes live.\n6.  **Finalize and Publish in GTM**: After',
    created: 1757324293781,
  },

  {
    session_id: 2029,
    type: 'message',
    content:
      ' reviewing the report and confirming everything looks correct, you can click "Go to GTM" to navigate to your Google Tag Manager workspace. There, you\'ll review the changes JTracking made and then "Submit" and "Publish" them to make your tracking live on your website.\n\nFor detailed step-by-step instructions on',
    created: 1757324294049,
  },

  {
    session_id: 2029,
    type: 'message',
    content:
      ' setting up Google Tag Manager with GA4, you can refer to our blog post: [How to Set Up Google Tag Manager with GA4](https://www.jtracking.ai/blog/how-to-set-up-google-tag-manager-gtm-and-integrate-it-with-google',
    created: 1757324294269,
  },

  {
    session_id: 2029,
    type: 'message',
    content:
      '-analytics-4-ga4-and-jtracking/) and the [Deployment Procedure Guide](https://www.jtracking.ai/blog/getting-started-with-jtracking-from-url-to-gtm-in-30-minutes/).',
    created: 1757324294458,
  },

  {
    session_id: 2029,
    type: 'suggestion',
    content: {
      suggestion1: "I'm ready to authorize and deploy this to my GTM.",
      suggestion2: 'Can you show me how to find my GTM details?',
      suggestion3: 'I want to view the pre-launch tracking report again.',
    },
    created: 1757324295870,
  },

  {
    session_id: 2011,
    type: 'done',
    content: 'done',
    created: 1756874600714,
  },
];

export const mockPlan = (
  originData,
  streamId,
  dataId,
  updateContent,
  setDisabled,
  handleUpdatePlan,
  addContent,
) => {
  let hasProgress = false;
  let planList = [] as PlanItemProps[];
  let suggestions = undefined as any;

  const data = deepCopy(originData);

  const interval = setInterval(() => {
    const message = data.shift();
    if (!message) return clearInterval(interval);
    handleData(message);
  }, 1000);

  const handleData = (message: Message) => {
    switch (message.type) {
      case 'system_message':
        if (message.content === '[START_GENERATING_PLAN]') {
          updateContent({
            contentId: streamId,
            dataId,
            key: 'type',
            method: 'REPLACE',
            content: 'PROGRESS',
          });
        }

        break;

      case 'plan_stage_progress':
        hasProgress = true;

        const progress = message.content as Record<string, any>;
        const detail = progress?.detail;

        if (progress) {
          const { title, stage, estimated_time, progress_max, progress_min } =
            progress;
          if (stage !== 'COMPLETED') {
            updateContent({
              contentId: streamId,
              key: 'progress',
              method: 'MERGE',
              content: {
                status: 'LOADING',
                phase: title,
                progress: {
                  set: 0,
                  step: 1,
                  max: 180,
                },
                info: detail ? `${detail.cluster}: ${detail.event}` : '',
              },
            });
          } else {
            updateContent({
              contentId: streamId,
              key: 'progress',
              method: 'MERGE',
              content: {
                status: 'SUCCESS',
                phase: title,
              },
            });
          }
        }

        break;

      case 'suggestion':
        suggestions = message.content;

        break;

      case 'done':
        if (planList.length > 0) {
          const tableResult = {
            id: uid(),
            type: 'PRODUCT',
            position: 'left',
            clickable: {
              type: 'PLAN',
              params: [],
            },
            header: {
              icon: greenStarIcon,
              label: `test`,
            },
            data: [
              {
                id: uid(),
                type: 'STREAM',
                content: {
                  stream: planList,
                },
              },
            ],
          };

          addContent(tableResult, false);
        }

        if (suggestions) {
          const suggestionContent = {
            id: uid(),
            type: 'NORMAL',
            position: 'left',
            data: [
              {
                id: uid(),
                type: 'SUGGESTION',
                content: {
                  list: suggestions,
                  title: '你可以这样提问',
                },
              },
            ],
          };

          addContent(suggestionContent, false);
        }

        setDisabled(false);

        break;

      case 'error':
        updateContent({
          contentId: streamId,
          key: 'data',
          method: 'REPLACE',
          content: [
            {
              id: uid(),
              type: 'TEXT',
              content: {
                data: message.content,
              },
            },
          ],
        });
        updateContent({
          contentId: streamId,
          key: 'operators',
          method: 'ADD',
          content: {
            id: 'retry',
            label: 'Retry',
            onClick: () => {},
          },
        });

        break;

      case 'tracking_event':
        planList.push(message.content as PlanItemProps);

        handleUpdatePlan(message.content as PlanItemProps);

        break;

      default:
        updateContent({
          contentId: streamId,
          dataId,
          key: 'stream',
          method: 'ADD',
          content: message,
        });
        break;
    }
  };
};
